// ── SCROLL REVEAL (opacity only, lightweight) ──
const revealObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('on'); revealObs.unobserve(e.target); }
  });
}, { threshold: 0.08 });
document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

// ── NAV SCROLL ──
const nav = document.querySelector('.site-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

// ── MOBILE MENU ──
const hamburger = document.querySelector('.nav-hamburger');
const mobileMenu = document.querySelector('.mobile-menu');
if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => {
    const open = hamburger.classList.toggle('open');
    mobileMenu.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    hamburger.setAttribute('aria-expanded', String(open));
  });
  mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    hamburger.classList.remove('open');
    mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
  }));
}

// ── CART TOAST ──
function showCartToast() {
  const toast = document.getElementById('cart-toast');
  if (!toast) return;
  toast.style.display = 'flex';
  requestAnimationFrame(() => requestAnimationFrame(() => toast.classList.add('show')));
  clearTimeout(toast._t);
  toast._t = setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => { toast.style.display = 'none'; }, 350);
  }, 3500);
}

// ── CART COUNT ──
function updateCartCount() {
  fetch('/cart.js').then(r => r.json()).then(d => {
    document.querySelectorAll('.nav-cart-count').forEach(el => {
      el.textContent = d.item_count;
      el.style.display = d.item_count > 0 ? 'inline-flex' : 'none';
    });
  }).catch(() => {});
}

// ── AJAX ADD TO CART ──
window.addToCart = async function(variantId, qty = 1, btn) {
  const orig = btn?.textContent;
  if (btn) { btn.disabled = true; btn.textContent = '…'; }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (res.ok) {
      showCartToast();
      updateCartCount();
      if (btn) { btn.textContent = '✓'; setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000); }
    } else {
      if (btn) { btn.textContent = orig; btn.disabled = false; }
    }
  } catch { if (btn) { btn.textContent = orig; btn.disabled = false; } }
};

// ── PRODUCT PAGE ──
(function() {
  const form = document.getElementById('addToCartForm');
  if (!form) return;
  let qty = 1, variantId = form.dataset.variantId;

  window.changeQty = d => {
    qty = Math.max(1, qty + d);
    const el = document.getElementById('qtyDisplay');
    if (el) el.textContent = qty;
  };
  window.selectVariant = (btn, id, price, available) => {
    document.querySelectorAll('.prod-variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    variantId = id;
    const p = document.getElementById('prodPrice');
    if (p) p.textContent = available ? price : 'Sold Out';
    const atc = document.getElementById('atcBtn');
    if (atc) { atc.textContent = available ? 'Add to Bag' : 'Sold Out'; atc.disabled = !available; }
  };
  window.setMainImg = (src, thumb) => {
    const img = document.getElementById('mainImgEl');
    if (img) { img.style.opacity = '0'; setTimeout(() => { img.src = src; img.style.opacity = '1'; }, 180); }
    document.querySelectorAll('.prod-thumb').forEach(t => t.classList.remove('active'));
    thumb?.classList.add('active');
  };
  window.toggleAccordion = btn => {
    const body = btn.nextElementSibling;
    const icon = btn.querySelector('.acc-icon');
    const open = body.classList.contains('open');
    document.querySelectorAll('.prod-accordion-body.open').forEach(b => {
      b.style.maxHeight = '0'; b.classList.remove('open');
      const i = b.previousElementSibling?.querySelector('.acc-icon');
      if (i) i.textContent = '+';
    });
    if (!open) {
      body.style.maxHeight = body.scrollHeight + 32 + 'px';
      body.classList.add('open');
      if (icon) icon.textContent = '−';
    }
  };

  const mainImg = document.getElementById('mainImgEl');
  if (mainImg) mainImg.style.transition = 'opacity .18s ease';

  form.addEventListener('submit', async e => {
    e.preventDefault();
    await window.addToCart(variantId, qty, document.getElementById('atcBtn'));
  });
})();

// ── COLLECTION QUICK ADD ──
document.querySelectorAll('.coll-card-add').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault(); e.stopPropagation();
    window.addToCart(btn.dataset.variantId, 1, btn);
  });
});

updateCartCount();
